<template>
  <div class="token-cpex-in-academy bg--color-01">
    <div
      class="token-cpex-in-academy__container-bg bg--color-02 pt-32 pt-64--m pb-32 pb-64--m"
    >
      <div class="token-cpex-in-academy__container container-new">
        <div
          class="token-cpex-in-academy__title txt txt--36px txt--height-44px txt--44px--m txt--height-58px--m txt--color-04 txt--bold"
        >
          {{ $t('tokenNew.cpexAcademyBlock.title') }}
        </div>

        <div class="token-cpex-in-academy__image">
          <img
            :src="require('@/assets/img/token/cpex-in-academy.svg')"
            loading="lazy"
            alt="token image"
          >
        </div>

        <div class="token-cpex-in-academy__content">
          <span
            class="txt txt--16px txt--height-20px txt--22px--m txt--height-30px--m txt--color-03"
            v-html="$t('tokenNew.cpexAcademyBlock.subtitle')"
          />

          <button-with-arrow
            full-width
            size="l"
            :to="localePath('/exchange')"
            class="token-cpex-in-academy__btn"
          >
            {{ $t('tokenNew.cpexAcademyBlock.buyNowBtn') }}
          </button-with-arrow>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    ButtonWithArrow: () =>
      import('@/components/welcome/elements/ButtonWithArrow.vue'),
  },
}
</script>

<style lang="scss" scoped>
.token-cpex-in-academy {
  &__container-bg {
    border-radius: toRem(20px) toRem(20px) 0 0;

    @include bp(l) {
      border-radius: toRem(60px) toRem(60px) 0 0;
    }
  }

  &__container {
    display: grid;
    gap: toRem(22px);
    grid-template-areas:
      'title'
      'image'
      'content';

    @include bp(m) {
      gap: toRem(24px) 0;
      grid-template-columns: 1fr 1fr;
      grid-template-areas:
        'title image'
        'content image';
    }
  }

  &__title {
    grid-area: title;

    @include bp(m) {
      align-self: flex-end;
    }
  }

  &__image {
    grid-area: image;
    text-align: center;

    img {
      width: 100%;
      max-width: toRem(380px);
    }

    @include bp(m) {
      text-align: right;

      img {
        max-width: 80%;
      }
    }
  }

  &__content {
    grid-area: content;
    display: flex;
    flex-direction: column;
    gap: toRem(18px);

    @include bp(m) {
      align-self: flex-start;
      gap: toRem(24px);
    }
  }

  &__btn {
    @include bp(m) {
      max-width: fit-content;
    }
  }
}
</style>
